<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/SzTAQO/tc-custom/9781488043079.jpg?1738382114228" alt="This image is the cover for the book Reunited in the Rockies, Rocky Mountain Heroes"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Reunited in the Rockies, Rocky Mountain Heroes
      </h1>
      <p class="bookDescription body article font2">
        <b>In this inspirational romance, a pregnant widow is reunited with her first love when they work together on a historic restoration in his small hometown.</b><br/><br/>For pregnant widow Kayla Bradshaw, restoring a historic Colorado hotel means a better life for her and her soon-to-arrive baby. But she needs construction help from Jude Stephens, the love she lost through a misunderstanding. Working with Kayla, the police officer finds himself forgiving her—and longing to rebuild her shattered confidence. But can they trust each other enough to forge a future together?<br/><br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mindy Obenhaus
      </h2>
      
      <p class="authorDescription body article">Award-winning author Mindy Obenhaus lives on a ranch in Texas with her husband, two sassy pups and countless cattle. She&rsquo;s passionate about touching readers with Biblical truths in an entertaining, and sometimes adventurous, manner. When she&rsquo;s not writing, you&rsquo;ll likely find her in the kitchen, spending time with her grandchildren or roaming the ranch in search of inspiration. She&rsquo;d love to connect with you via her website, mindyobenhaus.com, or on Facebook.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1839a0f8